import { useCallback, useEffect, useState } from 'react';
import { isStandaloneDisplay, needsHomeScreenInstall } from '../../services/webPush';

export const INSTALL_BENEFIT_COPY =
  'Installing lets MapToBe alert you for messages, friend requests, and saved events.';

/** Signed-in browser sessions only. Standalone and a saved dismiss both hide it. */
export function shouldOfferInstall({ standalone, signedIn, dismissed } = {}) {
  return Boolean(signedIn) && !standalone && dismissed !== true;
}

/** Chrome install prompt + iPhone Home Screen hint. Hidden once the app is standalone. */
export function useInstallApp() {
  const [installed, setInstalled] = useState(() => isStandaloneDisplay());
  const [deferred, setDeferred] = useState(null);
  const [hint, setHint] = useState('');

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if (isStandaloneDisplay()) setInstalled(true);
    const onPrompt = (event) => {
      event.preventDefault();
      setDeferred(event);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const install = useCallback(async () => {
    if (deferred && typeof deferred.prompt === 'function') {
      deferred.prompt();
      try {
        await deferred.userChoice;
      } catch {
        /* user dismissed the browser prompt */
      }
      setDeferred(null);
      return;
    }
    if (needsHomeScreenInstall()) {
      setHint('On iPhone, tap Share, then Add to Home Screen.');
      return;
    }
    setHint('Use the browser menu and choose Install.');
  }, [deferred]);

  return { installed, install, hint };
}
